export default class Preloader {
    static init () {}
    static update (__progress) {}
    static hide (__call) {
        if(__call) __call();
    }
}
